// Copyright ©️ 2026 eVolve MEP, LLC

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';

import ReactDOM from 'react-dom/client';

import { App } from 'app/App';
import { BrowserRouter } from 'BrowserRouter';
import { routerHistory } from 'routerHistory';

const AppWithProvider = () => (
  <BrowserRouter history={routerHistory}>
    <App />
  </BrowserRouter>
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<AppWithProvider />);
